import * as CONSTANTS from "../../utilities/Constants";
import { IInstrumentProperty } from "./InstrumentPropertyData";
import IInstrumentTypeData from "./InstrumentTypeData";
import IDirectionData from "../direction/directionData";
import INetworkConnectionData from "../networkConnection/NetworkConnectionData";
import IStationFormData from "../station/StationFormData";
import moment from "moment";
import DateFormatting from "../../utilities/DateFormat";

export interface IStatusType {
  id: string;
  name: string;
}

export default interface IStationData {
  id: string;
  name: string;
  description: string;
}

export interface IInstrumentViewData {
  id: string;
  name: string;

  codeId: string;
  serialNumber: string;
  type: IInstrumentTypeData;
  status: IStatusType;
  directionList: IDirectionData[];
  isEnabled: boolean;
  isCreatedManually: boolean;
  description: string;
  properties: IInstrumentProperty[];
  directions: string;
  state: string;
  isAutoline: boolean;
  networkConnection?: INetworkConnectionData[];
  isAssociated: boolean;
  instrumentStation: IStationData;
  connectionType?: string;
  ipAddress?: string;
  port?: string;
  directory?: string;
  propertiesCount?: string;
  createdOn?: string;
  formatedDate?: string;
}

export default class InstrumentViewData implements IInstrumentViewData {
  id: string;
  name: string;

  codeId: string;
  serialNumber: string;
  type: IInstrumentTypeData;
  status: IStatusType;
  directionList: IDirectionData[];
  isEnabled: boolean;
  isCreatedManually: boolean;
  description: string;
  properties: [];
  directions: string;
  state: string;
  isAutoline: boolean;
  networkConnection?: INetworkConnectionData[];
  isAssociated: boolean;
  instrumentStation: IStationData;
  connectionType?: string;
  ipAddress?: string;
  port?: string;
  directory?: string;
  propertiesCount?: string;
  createdOn?: string;
  formatedDate?: string;

  constructor(
    id: string,
    name: string,
    codeId: string,
    serialNumber: string,
    type: IInstrumentTypeData,
    status: IStatusType,
    directionList: IDirectionData[],
    isEnabled: boolean,
    isCreatedManually: boolean,
    description: string,
    properties: [],
    isAutoline: boolean,
    isAssociated: boolean,
    instrumentStation?: IStationData,
    networkConnection?: INetworkConnectionData[],
    connectionType?: string,
    ipAddress?: string,
    port?: string,
    directory?: string,
    propertiesCount?: string,
    createdOn?: string
  ) {
    this.id = id;
    this.name = name;
    this.codeId = codeId;
    this.serialNumber = serialNumber;
    this.type = type;
    this.status = status;
    this.directionList = directionList;
    this.isEnabled = isEnabled;
    this.isCreatedManually = isCreatedManually;
    this.description = description;
    this.properties = properties;
    this.isAutoline = isAutoline;
    this.networkConnection = networkConnection;
    this.instrumentStation = instrumentStation;
    this.connectionType = connectionType;
    this.ipAddress = ipAddress;
    this.port = port;
    this.directory = directory;
    const d: string[] = [];
    directionList.forEach((t: IDirectionData) => {
      if (t.name === CONSTANTS.ND) {
        d.push("--");
      } else {
        d.push(t.name);
      }
    });
    this.directions = d.toString();

    this.state = isEnabled ? CONSTANTS.ENABLED : CONSTANTS.DISABLED;
    this.isAssociated = isAssociated;
    this.propertiesCount = propertiesCount;
    this.createdOn = createdOn
      ? moment.utc(createdOn)
      .utcOffset(DateFormatting.getDateTimeRegionOffset())
      .format(DateFormatting.getDateTimeRegion())
      : createdOn;
    this.formatedDate = createdOn
      ? moment.utc(createdOn)
      .utcOffset(DateFormatting.getDateTimeRegionOffset())
      .format(DateFormatting.getDateTimeRegion())
      : createdOn;
  }
}

const defaultInstrumentViewData = new InstrumentViewData(
  "",
  "",
  "",
  "",
  {
    id: "",
    name: "",
    description: "",
  },
  {
    id: "",
    name: "",
  },
  [],
  false,
  false,
  "",
  [],
  false,
  false,
  null,
  [],
  "",
  "",
  "",
  ""
);
export { defaultInstrumentViewData as defaultInstrumentData };
